import React from "react";
import { Create, Edit, TextInput } from "admin-on-rest";
import { SelectArrayChipInput } from "../components/selectchip";
import IconTitle from "../components/icon_title";
import OlaForm from "../components/form/OlaForm";

const CategoryForm = props => (
  <OlaForm {...props}>
    <TextInput label="resources.categories.fieldList.name" source="name" />
    <SelectArrayChipInput
      label="resources.categories.fieldList.property"
      source="properties"
    />
  </OlaForm>
);

export const CategoryCreate = props => (
  <Create
    {...props}
    title={<IconTitle icon="categories" title={"resources.categories.title"} />}
  >
    <CategoryForm {...props} />
  </Create>
);

export const CategoryEdit = props => (
  <Edit
    {...props}
    title={<IconTitle icon="categories" title={"resources.categories.title"} />}
  >
    <CategoryForm {...props} />
  </Edit>
);



// WEBPACK FOOTER //
// ./src/categories/Create.js